import type { ConfigType } from '@plone/registry';

export default function applyConfig(config: ConfigType) {
  // disable styles for all blocks
  config.settings.pluggableStylesBlocksWhitelist = ['none'];

  return config;
}
